export default __webpack_public_path__ + "static/media/AKhlak Hossain Jim Projects Analog Clock 960.6e2a26fb.webp";